var path = 'src/app/patients/hnf1b/clinical-pictures.html';
var html = "<h1 class=page-header>Clinical Pictures</h1> <div hnf1b-clinical-pictures-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/hnf1b/clinical-pictures.html
 ** module id = 481
 ** module chunks = 0
 **/